import {WrapperFactory} from "../WrapperFactory";
import { ProductsClassesGroup } from "../../models/ProductsClassesGroup";
import { ProductsClass } from "../../models/ProductsClass";

let productsClassesGroupsApi = {
    async get(token, companyId,params={}, select=[], relationships=[]){
        let response = await window.axios.get('/api/products-classes-groups', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params,
                select:select,
                relationships:relationships
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new ProductsClassesGroup(e));
        return wrapper;
    },
    async find(id, token, companyId, params={}){
        let response = await window.axios.get('/api/products-classes-groups/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
    async create(productsClassesGroup, token, companyId, params = {}){
        let response = await window.axios.post('/api/products-classes-groups', productsClassesGroup, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });

        return new ProductsClassesGroup(response.data);
    },
    async edit(productsClassesGroup, token, companyId){
        let response = await window.axios.put('/api/products-classes-groups/'+productsClassesGroup.id, productsClassesGroup, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new ProductsClassesGroup(response.data);
    },
    async delete(productsClassesGroup, token, companyId){
        let response = await window.axios.delete('/api/products-classes-groups/'+productsClassesGroup.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async getAllClasses(token, companyId, params={}){
        let response = await window.axios.get('/api/products-classes-groups/classes', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new ProductsClass(e));
        return wrapper;
    },
    async saveClass(productsClass, token, companyId, params = {}){
        if(productsClass.id)
            var url = '/api/products-classes-groups/classes/'+productsClass.id;
        else
            var url = '/api/products-classes-groups/classes';

        let response = await window.axios.post(url, productsClass, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });

        return new ProductsClass(response.data);
    },
    async deleteClass(productsClass, token, companyId){
        let response = await window.axios.delete('/api/products-classes-groups/classes/'+productsClass.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async getVariable(id, token, companyId, params={}){
        let response = await window.axios.get('/api/products-classes-groups/variable/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
    async deleteVariable(variable, token, companyId){
        console.log('deleteVariable variable api', variable);
        let response = await window.axios.delete('/api/products-classes-groups/variables/'+variable.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async findClass(id, token, companyId, params={}){
        let response = await window.axios.get('/api/products-classes-groups/class/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
}

export default productsClassesGroupsApi